export default "__VITE_ASSET__Bu653s4i__"